import { BookingLayout } from '@drycut/booking-components';
import { Error404, Loader } from '@drycut/ui-components';
import { RollbarContext } from '@rollbar/react';
import React from 'react';
import { createBrowserRouter, Outlet } from 'react-router';

import {
  BookingDetailsByUid,
  CustomerPreferences,
  CustomerSettings,
  NewBookingCheckout,
  NewBookingReview,
  NewPassPurchase,
  PassDetailsByUid,
  Passes,
  PassPurchaseError,
  PreBookingDetailsByUid,
  Salons,
} from './routes';

export default createBrowserRouter([
  {
    path: '/checkout',
    element: (
      <RollbarContext context="/checkout">
        <NewBookingCheckout />
      </RollbarContext>
    ),
  },
  {
    path: '/checkout/:slug',
    element: (
      <RollbarContext context="/checkout/slug">
        <NewBookingCheckout />
      </RollbarContext>
    ),
  },
  {
    path: '/',
    loader: () => {
      window.location.href = '/checkout';
      return null;
    },
    element: (
      <RollbarContext context="/(salons)">
        <Salons />
      </RollbarContext>
    ),
  },
  {
    path: '/:slug',
    element: (
      <RollbarContext context="/slug">
        <NewBookingCheckout />
      </RollbarContext>
    ),
  },
  {
    element: (
      <BookingLayout src="/images/booking-bg.jpg">
        <React.Suspense fallback={<Loader />}>
          <Outlet />
        </React.Suspense>
      </BookingLayout>
    ),
    children: [
      {
        path: '/booking/:uid',
        element: (
          <RollbarContext context="/booking/details">
            <BookingDetailsByUid />
          </RollbarContext>
        ),
      },
      {
        path: '/pre_booking/:uid',
        element: (
          <RollbarContext context="/">
            <PreBookingDetailsByUid />
          </RollbarContext>
        ),
      },
      {
        path: '/booking/payment-error/:transactionId',
        element: (
          <RollbarContext context="/booking/payment-error">
            <PassPurchaseError />
          </RollbarContext>
        ),
      },
      {
        path: '/review/:bookingUid',
        element: (
          <RollbarContext context="/review/bookingUid">
            <NewBookingReview />
          </RollbarContext>
        ),
      },
      {
        path: '/passes',
        element: (
          <RollbarContext context="/passes">
            <Passes />
          </RollbarContext>
        ),
      },
      {
        path: '/passes/:passId/purchase',
        element: (
          <RollbarContext context="/passes/passId/purchase">
            <NewPassPurchase />
          </RollbarContext>
        ),
      },
      {
        path: '/pass/:uid',
        element: (
          <RollbarContext context="/pass/uid">
            <PassDetailsByUid />
          </RollbarContext>
        ),
      },
      {
        path: '/passes/payment-error/:transactionId',
        element: (
          <RollbarContext context="/passes/payment-error/transactionId">
            <PassPurchaseError />
          </RollbarContext>
        ),
      },
      {
        path: '/preferences/:code',
        element: (
          <RollbarContext context="/preferences/code">
            <CustomerPreferences />
          </RollbarContext>
        ),
      },
      {
        path: '/settings/:code',
        element: (
          <RollbarContext context="/settings/code">
            <CustomerSettings />
          </RollbarContext>
        ),
      },
    ],
  },
  {
    path: '/not-found',
    element: (
      <RollbarContext context="/not-found">
        <Error404 />
      </RollbarContext>
    ),
  },
  {
    path: '*',
    element: (
      <RollbarContext context="(catchall)">
        <Error404 />
      </RollbarContext>
    ),
  },
]);
